<!--SUBSCRIPTION LIST-->
<app-card-container
  [title]="'Subscriptions'"
  [cardType]="'subscription'"
  [description]="
    'New to the Genesys ecosystem and looking for an economical way to become a subject matter expert on your Genesys platform?
        A learning subscription is the best way to maximize your time and budget for training. Each learning subscription provides individual users with access
        to the top training and certifications for each platform for one year. Learn more about each of the subscriptions below!'
  "
  [containerBackgroundCss]="!isLightMode ? 'neutral-background' : ''">
  <!--SUBSCRIPTION LIST CARDS-->
  <section class="card-carousel">
    <!--FIXED SUBSCRIPTION LIST-->
    <ngu-carousel #myCarousel [inputs]="carouselTile" [dataSource]="subscriptionItems">
      <!--LEFT ARROW START-->
      <i
        NguCarouselPrev
        class="leftRs icon white small arrow-left left-arrow cursor"
        [style.opacity]="myCarousel.isFirst ? 0.5 : 1"></i>
      <!--END LEFT ARROW-->

      <!--CAROUSEL CONTENT START-->
      <ngu-tile class="embed-container" *nguCarouselDef="let subscriptionItem; index as i">
        <app-card
          [cardType]="cardType.SUBSCRIPTION"
          [icon]="[subscriptionItem?.icon, 'small', 'white']"
          [customHeaderCss]="'subscription'"
          [customCardHeightCss]="'card-max-height'"
          [customHeadingGroupCss]="'card-heading-group'"
          [title]="subscriptionItem?.name"
          [route]="subscriptionItem?.slugName"
          [buttonRoute]="subscriptionItem?.slugName"
          [description]="subscriptionItem?.description"
          (sendClick)="
            sendGoogleAnalytics('Subscription List', 'click', subscriptionItem?.slugName)
          "
          [customButtonCss]="'btn-inverse'"
          [actionLabel]="cardTypeCallToActions.LEARN_MORE">
        </app-card>
      </ngu-tile>
      <!--END CAROUSEL CONTENT-->
      <!--RIGHT ARROW START-->
      <i
        NguCarouselNext
        class="rightRs icon white small arrow-right right-arrow cursor"
        [style.opacity]="myCarousel.isLast ? 0.5 : 1"></i>
      <!--END RIGHT ARROW -->

      <!--SLIDER DOTS START-->
      <ul class="myPoint cursor" NguCarouselPoint>
        <li
          *ngFor="
            let i of myCarousel.pointNumbers();
            let j = index;
            trackBy: trackBySubscriptionItemId
          "
          [ngClass]="i === myCarousel.activePoint ? carouselDotActiveCSS : ''"
          (click)="myCarousel.moveTo(i)"
          [style.background]="'url(' + subscriptionItems[i] + ')'"></li>
      </ul>
      <!--END SLIDER DOTS-->
    </ngu-carousel>
    <!--END FIXED SUBSCRIPTION LIST-->
  </section>
  <!--END SUBSCRIPTION LIST CARDS-->
</app-card-container>
<!--END SUBSCRIPTION LIST-->
